import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EnterprisePrimaryAdminService {
    private http = inject(HttpClient);


    baseUrl = '';

    constructor() {
        this.baseUrl = environment.apiUrl + '/api/v1/enterprise-primary-admin';
    }

    addRole(userId: string): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/role/${userId}/add`, null);
    }

    removeRole(userId: string): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/role/${userId}/remove`, null);
    }
}
